import React, { Component } from 'react';
import logo from './content/Edit.png';
export default class Header extends Component {
    render() {
        return (
            <img src={logo} style={{ marginLeft:'10px' }} alt='edit'/>
        );
    }
}